import SliderService from "../../../services/SliderService";

export default {
  namespaced: true,
  state: () => ({
    sliderListesi: null,
  }),
  mutations: {
    setSliderListesi: (state, value) => {
      state.sliderListesi = value;
    },
  },
  actions: {
    sliderListesi: ({ commit }) => {
      return new Promise((resolve, reject) => {
        SliderService.sliderListesi()
          .then((res) => {
            if (res.status === 200) {
              commit("setSliderListesi", res.data);
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sliderKaldir: ({ dispatch }, sliderCode) => {
      return new Promise((resolve, reject) => {
        SliderService.sliderKaldir(sliderCode)
          .then((res) => {
            if (res.status === 200) {
              dispatch("sliderListesi");
            }
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
};
